module.exports = __webpack_public_path__ + "img/side-icon-54.9c030e18.svg";